// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gradecheckimage[data-v-70dfe026]{height:20px}.gradeboxlabel[data-v-70dfe026]{margin:0}", ""]);
// Exports
module.exports = exports;
